import { createContext, useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import Preloader from "../../components/Preloader";
import axiosManager from "../../services/axiosManager";

const FeaturesContext = createContext(undefined);

const { Provider } = FeaturesContext;

const FeaturesProvider = ({ children }) => {
    const { isFetching: isLoadingFeatures, data: featuresNames, isSuccess } = useQuery({
        queryKey: ["features/names"],
        queryFn: () => axiosManager.get$("/parent/api/features/names").then((response) => response?.data),
        retry: 0,
    });

    const { isFetching: isLoadingFeaturesEnabling, data: features } = useQuery({
        queryKey: ["features/enabling"],
        queryFn: () => axiosManager.get$(`/parent/api/features?featureNames=${featuresNames.join('&featureNames=')}`).then((response) => response?.data),
        enabled: isSuccess,
        retry: 0,
    });

    const isFeatureEnabled = useCallback((featureName) => !!(features || [])
        .find((it) => it.featureName === featureName)?.enabled, [features]);

    const value = {
        featuresNames,
        features,
        isFeatureEnabled,
    };

    return (
        <Preloader isLoading={isLoadingFeatures || isLoadingFeaturesEnabling}>
            <Provider value={value}>
                {children}
            </Provider>
        </Preloader>
    );
};

export {
    FeaturesProvider,
    FeaturesContext,
};
